import script from "./PermissionDenied.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&setup=true&lang=js"

import "./PermissionDenied.vue?vue&type=style&index=0&id=3ea4aa8d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea4aa8d"]])

export default __exports__